module.exports = __webpack_public_path__ + "24e004ab/img/rename-icon.de4e673d.svg";